var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('ShareFileDialog'),_c('ShareViewDialog'),_c('DeleteFileDialog'),_c('AllFilesTable')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }